export default __webpack_public_path__ + "static/media/vernemq.08dc2cd2.svg";